import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, Ref, watch, onMounted, onUnmounted } from 'vue';
import DeviceSelect from './DeviceSelect.vue';
import VideoProfile from './VideoProfile.vue';
import { useBasicStore } from '../../../stores/basic';
import { useRoomStore } from '../../../stores/room';
import TUIRoomCore from '../../tui-room-core';
import { storeToRefs } from 'pinia';
import { SettingMode } from '../../../constants/render';

interface Props {
  mode?: SettingMode,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSettingTab',
  props: {
    mode: null
  },
  setup(__props: any) {

const props = __props as {
  mode?: SettingMode,
}


const settingMode = props.mode || SettingMode.SIMPLE;
const isSampleMode = computed(() => settingMode === SettingMode.SIMPLE);
const isDetailMode = computed(() => settingMode === SettingMode.DETAIL);

const testCameraPreviewRef = ref();

const basicStore = useBasicStore();

const isLocalStreamMirror: Ref<boolean> = ref(basicStore.isLocalStreamMirror);
watch(isLocalStreamMirror, (val: boolean) => {
  TUIRoomCore.setVideoMirror(val);
  basicStore.setIsLocalStreamMirror(val);
});

const roomStore = useRoomStore();
const { currentCameraId } = storeToRefs(roomStore);

// 点击【更多摄像头设置】
function handleMoreCameraSetting() {
  basicStore.setShowSettingDialog(true);
  basicStore.setActiveSettingTab('video');
}

if (isDetailMode.value) {
  watch(currentCameraId, (val) => {
    TUIRoomCore.setCurrentCamera(val);
  });

  onMounted(() => {
    TUIRoomCore.startCameraDeviceTest(testCameraPreviewRef.value);
  });

  onUnmounted(() => {
    TUIRoomCore.stopCameraDeviceTest();
  });
}


return { __sfc: true,props, settingMode, isSampleMode, isDetailMode, testCameraPreviewRef, basicStore, isLocalStreamMirror, roomStore, currentCameraId, handleMoreCameraSetting, DeviceSelect, VideoProfile }
}

})